import {Inject, Pipe, PipeTransform} from "@angular/core";
import {ROUTER_PATHS_TOKEN} from "./routes-pipe.token";


@Pipe({
  name: 'routerPath'
})
export class RoutesPipeDirective implements PipeTransform{
  constructor(@Inject(ROUTER_PATHS_TOKEN) private readonly routesList: {[key: string]: any}) {
  }
  transform(value: string): string {
    // @ts-ignore
    return this.routesList[value];
  }
}
